class TestimonialsCarousel {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.carousel = document.getElementById(`testimonials-${sectionId}`);
    if (!this.carousel) return;
    this.track = this.carousel.querySelector(".testimonials-track");
    this.originalCards = this.carousel.querySelectorAll(".testimonial-card");
    this.prevButton = this.carousel.querySelector(".nav-button.prev");
    this.nextButton = this.carousel.querySelector(".nav-button.next");
    this.dots = this.carousel.querySelectorAll(".dot");
    this.isMobile = window.innerWidth < 750;
    this.isAnimating = !1;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.touchEndY = 0;
    this.isSwiping = !1;

    // Mouse drag state
    this.isDragging = !1;
    this.dragStartX = 0;
    this.dragEndX = 0;
    this.hasDragged = !1;

    // Autoplay
    this.autoplayInterval = null;
    this.autoplayDelay = 3500; // ms between slides

    this.init();
  }
  init() {
    this.setupCards();
    this.bindEvents();
    setTimeout(() => {
      this.updateCarousel(!1);
      this.startAutoplay();
    }, 100);
  }

  /* ─── Autoplay ─────────────────────────────────────────── */
  startAutoplay() {
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      if (this.isAnimating) return;
      this.isAnimating = !0;
      this.isMobile
        ? this.originalCards.length > 1
          ? this.currentSlide++
          : (this.currentSlide =
              this.currentSlide === this.totalSlides - 1 ? 0 : this.currentSlide + 1)
        : this.currentSlide++;
      this.updateCarousel(!0);
      setTimeout(() => { this.isAnimating = !1; }, 350);
    }, this.autoplayDelay);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  resetAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  /* ─── Original setupCards (unchanged) ──────────────────── */
  setupCards() {
    if (this.isMobile) {
      if (this.originalCards.length > 1) {
        const lastCardClone = this.originalCards[this.originalCards.length - 1].cloneNode(!0);
        const firstCardClone = this.originalCards[0].cloneNode(!0);
        lastCardClone.classList.add("testimonial-clone", "mobile-clone-before");
        firstCardClone.classList.add("testimonial-clone", "mobile-clone-after");
        this.track.insertBefore(lastCardClone, this.track.firstChild);
        this.track.appendChild(firstCardClone);
        this.cards = this.track.querySelectorAll(".testimonial-card");
        this.currentSlide = 1;
        this.totalSlides = this.originalCards.length;
      } else {
        this.cards = this.originalCards;
        this.currentSlide = 0;
        this.totalSlides = this.originalCards.length;
      }
    } else {
      if (this.originalCards.length > 1) {
        const clonesBefore = Array.from(this.originalCards).map((card) => {
          const clone = card.cloneNode(!0);
          clone.classList.add("testimonial-clone", "clone-before");
          return clone;
        });
        const clonesAfter = Array.from(this.originalCards).map((card) => {
          const clone = card.cloneNode(!0);
          clone.classList.add("testimonial-clone", "clone-after");
          return clone;
        });
        clonesBefore.forEach((clone) => this.track.insertBefore(clone, this.track.firstChild));
        clonesAfter.forEach((clone) => this.track.appendChild(clone));
        this.cards = this.track.querySelectorAll(".testimonial-card");
        this.currentSlide = this.originalCards.length;
        this.totalSlides = this.originalCards.length;
      } else {
        this.cards = this.originalCards;
        this.currentSlide = 0;
        this.totalSlides = this.originalCards.length;
      }
    }
  }

  /* ─── Original updateCarousel (unchanged) ──────────────── */
  updateCarousel(animate = !0) {
    if (!this.cards[this.currentSlide]) return;
    if (this.isMobile) {
      const targetCard = this.cards[this.currentSlide];
      if (!targetCard) return;
      const containerRect = this.carousel.getBoundingClientRect();
      const cardRect = targetCard.getBoundingClientRect();
      const containerCenter = containerRect.left + containerRect.width / 2;
      const cardCenter = cardRect.left + cardRect.width / 2;
      const currentTransform = getComputedStyle(this.track).transform;
      let currentOffset = 0;
      if (currentTransform && currentTransform !== "none") {
        const matrix = new DOMMatrix(currentTransform);
        currentOffset = matrix.m41;
      }
      const centeringError = cardCenter - containerCenter;
      const newOffset = currentOffset - centeringError;
      if (animate) {
        this.track.style.transition = "transform 0.3s ease";
      } else {
        this.track.style.transition = "none";
      }
      this.track.style.transform = `translateX(${newOffset}px)`;
      if (this.originalCards.length > 1) {
        if (this.currentSlide === 0) {
          setTimeout(
            () => { this.currentSlide = this.totalSlides; this.updateCarousel(!1); },
            animate ? 300 : 0,
          );
        } else if (this.currentSlide === this.totalSlides + 1) {
          setTimeout(
            () => { this.currentSlide = 1; this.updateCarousel(!1); },
            animate ? 300 : 0,
          );
        }
      }
    } else {
      const cardWidth = this.cards[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const containerWidth = this.carousel.offsetWidth;
      const cardPosition = (cardWidth + gap) * this.currentSlide;
      const centerOffset = containerWidth / 2 - cardWidth / 2;
      const twoCardsOffset = (cardWidth + gap) * 2;
      const newOffset = -(cardPosition - centerOffset + twoCardsOffset);
      if (animate) {
        this.track.style.transition = "transform 0.3s ease";
      } else {
        this.track.style.transition = "none";
      }
      this.track.style.transform = `translateX(${newOffset}px)`;
      if (this.originalCards.length > 1) {
        setTimeout(
          () => {
            if (this.currentSlide < this.totalSlides) {
              this.currentSlide = this.totalSlides + this.currentSlide;
              this.updateCarousel(!1);
            } else if (this.currentSlide >= this.totalSlides * 2) {
              this.currentSlide = this.totalSlides + (this.currentSlide - this.totalSlides * 2);
              this.updateCarousel(!1);
            }
          },
          animate ? 350 : 10,
        );
      }
    }
    if (this.prevButton) this.prevButton.disabled = !1;
    if (this.nextButton) this.nextButton.disabled = !1;
    let realCardIndex;
    if (this.isMobile) {
      if (this.originalCards.length > 1) {
        realCardIndex =
          this.currentSlide === 0
            ? this.totalSlides - 1
            : this.currentSlide === this.totalSlides + 1
              ? 0
              : this.currentSlide - 1;
      } else {
        realCardIndex = this.currentSlide;
      }
    } else {
      if (this.currentSlide < this.totalSlides) {
        realCardIndex = this.currentSlide;
      } else if (this.currentSlide >= this.totalSlides * 2) {
        realCardIndex = this.currentSlide - this.totalSlides * 2;
      } else {
        realCardIndex = this.currentSlide - this.totalSlides;
      }
    }
    this.dots.forEach((dot, index) => {
      dot.classList.toggle("active", index === realCardIndex);
    });
  }

  /* ─── bindEvents: add mouse drag + pause-on-hover ───────── */
  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener("click", () => {
        if (this.isAnimating) return;
        this.isAnimating = !0;
        if (this.isMobile) {
          this.originalCards.length > 1
            ? this.currentSlide--
            : (this.currentSlide = this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1);
        } else {
          this.currentSlide--;
        }
        this.updateCarousel();
        this.resetAutoplay();
        setTimeout(() => { this.isAnimating = !1; }, 350);
      });
    }
    if (this.nextButton) {
      this.nextButton.addEventListener("click", () => {
        if (this.isAnimating) return;
        this.isAnimating = !0;
        if (this.isMobile) {
          this.originalCards.length > 1
            ? this.currentSlide++
            : (this.currentSlide = this.currentSlide === this.totalSlides - 1 ? 0 : this.currentSlide + 1);
        } else {
          this.currentSlide++;
        }
        this.updateCarousel();
        this.resetAutoplay();
        setTimeout(() => { this.isAnimating = !1; }, 350);
      });
    }
    this.dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        if (this.isAnimating) return;
        this.isAnimating = !0;
        if (this.isMobile) {
          this.currentSlide = this.originalCards.length > 1 ? index + 1 : index;
        } else {
          this.currentSlide = this.totalSlides + index;
        }
        this.updateCarousel();
        this.resetAutoplay();
        setTimeout(() => { this.isAnimating = !1; }, 350);
      });
    });

    // Pause autoplay when user hovers over carousel
    this.carousel.addEventListener("mouseenter", () => this.stopAutoplay());
    this.carousel.addEventListener("mouseleave", () => {
      if (!this.isDragging) this.startAutoplay();
    });

    this.bindTouchEvents();
    this.bindMouseDragEvents();

    window.addEventListener("resize", () => {
      setTimeout(() => this.updateCarousel(!1), 50);
    });
  }

  /* ─── Mouse drag (desktop) ──────────────────────────────── */
  bindMouseDragEvents() {
    const minDragDistance = 50;

    const onMouseDown = (e) => {
      // Ignore right-click
      if (e.button !== 0) return;
      this.isDragging = !0;
      this.hasDragged = !1;
      this.dragStartX = e.clientX;
      this.dragEndX = e.clientX;
      this.track.style.cursor = "grabbing";
      this.track.style.userSelect = "none";
      // Pause autoplay while dragging
      this.stopAutoplay();
    };

    const onMouseMove = (e) => {
      if (!this.isDragging) return;
      this.dragEndX = e.clientX;
      const delta = this.dragEndX - this.dragStartX;
      if (Math.abs(delta) > 5) {
        this.hasDragged = !0;
      }
    };

    const onMouseUp = (e) => {
      if (!this.isDragging) return;
      this.isDragging = !1;
      this.track.style.cursor = "grab";
      this.track.style.userSelect = "";

      const delta = this.dragEndX - this.dragStartX;

      if (Math.abs(delta) >= minDragDistance && !this.isAnimating) {
        this.isAnimating = !0;
        if (delta > 0) {
          // Dragged right → go prev
          this.isMobile
            ? this.originalCards.length > 1
              ? this.currentSlide--
              : (this.currentSlide = this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1)
            : this.currentSlide--;
        } else {
          // Dragged left → go next
          this.isMobile
            ? this.originalCards.length > 1
              ? this.currentSlide++
              : (this.currentSlide = this.currentSlide === this.totalSlides - 1 ? 0 : this.currentSlide + 1)
            : this.currentSlide++;
        }
        this.updateCarousel(!0);
        setTimeout(() => { this.isAnimating = !1; }, 350);
      }

      // Resume autoplay (carousel is still hovered → don't restart yet;
      // mouseleave will handle it)
      if (!this.carousel.matches(":hover")) {
        this.startAutoplay();
      }
    };

    // Prevent click propagation on links/buttons inside cards when a drag occurred
    const onClickCapture = (e) => {
      if (this.hasDragged) {
        e.stopPropagation();
        e.preventDefault();
        this.hasDragged = !1;
      }
    };

    this.track.style.cursor = "grab";
    this.track.addEventListener("mousedown", onMouseDown);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    this.track.addEventListener("click", onClickCapture, !0);
  }

  /* ─── Touch events (original, with resetAutoplay added) ─── */
  bindTouchEvents() {
    const handleTouchStart = (e) => {
      if (this.isAnimating) return;
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.isSwiping = !0;
      this.stopAutoplay();
    };
    const handleTouchMove = (e) => {
      if (!this.isSwiping) return;
      this.touchEndX = e.touches[0].clientX;
      this.touchEndY = e.touches[0].clientY;
      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 20) {
        e.preventDefault();
      }
    };
    const handleTouchEnd = (e) => {
      if (!this.isSwiping || this.isAnimating) return;
      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const minSwipeDistance = 50;
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
        this.isAnimating = !0;
        if (deltaX > 0) {
          this.isMobile
            ? this.originalCards.length > 1
              ? this.currentSlide--
              : (this.currentSlide = this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1)
            : this.currentSlide--;
        } else {
          this.isMobile
            ? this.originalCards.length > 1
              ? this.currentSlide++
              : (this.currentSlide = this.currentSlide === this.totalSlides - 1 ? 0 : this.currentSlide + 1)
            : this.currentSlide++;
        }
        this.updateCarousel(!0);
        setTimeout(() => { this.isAnimating = !1; }, 350);
      }
      this.isSwiping = !1;
      this.startAutoplay();
    };
    this.track.addEventListener("touchstart", handleTouchStart, { passive: !1 });
    this.track.addEventListener("touchmove", handleTouchMove, { passive: !1 });
    this.track.addEventListener("touchend", handleTouchEnd, { passive: !0 });
    this.track.addEventListener("contextmenu", (e) => { e.preventDefault(); });
  }
}

const initTestimonialsCarousel = (container) => {
  if (!container || container.dataset.carouselInitialized === "true") return;
  container.dataset.carouselInitialized = "true";
  const sectionId = container.id.replace("testimonials-", "");
  new TestimonialsCarousel(sectionId);
};

const initTestimonialsCarousels = () => {
  const testimonialsContainers = document.querySelectorAll('[id^="testimonials-"]');
  testimonialsContainers.forEach((container) => {
    initTestimonialsCarousel(container);
  });
};

document.addEventListener("DOMContentLoaded", function () {
  initTestimonialsCarousels();
});

document.addEventListener("shopify:section:load", function (event) {
  const sectionId = event?.detail?.sectionId;
  if (!sectionId) return;
  const container = document.getElementById(`testimonials-${sectionId}`);
  initTestimonialsCarousel(container);
});